import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CapacityTile } from "@/components/common/CapacityTile";
import { PlatformModuleUsageRankingDto } from "@/types/admin-analytics";
import { formatCount, titleCaseModule } from "../utils/format";

interface ModuleUsageRankingCardProps {
  moduleUsage: PlatformModuleUsageRankingDto[];
}

export const ModuleUsageRankingCard: React.FC<ModuleUsageRankingCardProps> = ({
  moduleUsage,
}) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base font-semibold">
          {t("analytics.platform.moduleUsage.title")}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        {moduleUsage.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            {t("analytics.platform.moduleUsage.empty")}
          </p>
        ) : (
          moduleUsage.map((entry, index) => (
            <CapacityTile
              key={`${entry.module}-${index}`}
              label={`#${index + 1} ${
                titleCaseModule(entry.module) ||
                t("analytics.platform.moduleUsage.unknown")
              }`}
              value={formatCount(entry.requestCount)}
              hint={t("analytics.platform.moduleUsage.share", {
                percent: entry.sharePercent,
              })}
              bar={{ percent: entry.sharePercent }}
            />
          ))
        )}
      </CardContent>
    </Card>
  );
};
